import { BuildingSummary } from '../types/protocols';
import { FilterCheckboxOption } from '../Pages/Förvaltning/components/FilterCheckboxColumn';

export const UNNAMED_BUILDING_LABEL = 'Namnlös byggnad';

/**
 * One filter row per building, sorted by name with Swedish collation.
 * Nameless buildings are labelled and sorted as "Namnlös byggnad".
 */
export function buildingFilterOptions(buildings: BuildingSummary[] | undefined): FilterCheckboxOption[] {
    return (buildings ?? [])
        .filter(building => Boolean(building.key))
        .map(building => ({ key: building.key, label: building.name?.trim() || UNNAMED_BUILDING_LABEL }))
        .sort((a, b) => a.label.localeCompare(b.label, 'sv'));
}

/**
 * Whether an item in the given building passes a building filter where
 * `deselected` holds the unchecked keys out of `knownKeys` (every building).
 *
 * Nothing deselected: filter inactive, everything shows. Everything
 * deselected: nothing shows. A key that is not a known building (deleted,
 * or summaries not loaded) is included rather than hidden for missing data,
 * like the type and group filters do.
 */
export function matchesBuildingKey(
    buildingKey: string,
    deselected: ReadonlySet<string>,
    knownKeys: ReadonlySet<string>
): boolean {
    if (deselected.size === 0) return true;
    if (deselected.size >= knownKeys.size) return false;
    if (!knownKeys.has(buildingKey)) return true;
    return !deselected.has(buildingKey);
}
